import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Checkbox from '../Checkbox/Checkbox';
import Icon from '../Icon/Icon';
import Group from '../Group/Group';
import SelectList from './SelectList';

const OPTIONS = [];
for (let i = 1; i <= 10; i++) {
  OPTIONS.push({
    label: `This is option ${i}`,
    value: `option-${i}`,
  });
}
const NESTED_OPTIONS = [{
  value: 'complex-1',
  label: 'Nested root',
  selectable: true,
  children: [{
    value: 'complex-2',
    label: 'Next level',
    selectable: true,
  }, {
    value: 'complex-2.1',
    label: 'Not selectable',
    selectable: false,
    children: [{
      value: 'complex-3',
      label: 'Deeper',
      selectable: true,
      children: [{
        value: 'complex-4',
        label: 'Rock bottom',
        selectable: true,
      }],
    }],
  }],
}, {
  value: 'last-option',
  label: 'Last option',
  selectable: true,
}];

export default class SelectListExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orgOptions: OPTIONS,
      options: OPTIONS,
    };
  }

  onChange = e => {
    window.showAppInfo((e.target.value && e.target.value.label) || e.target.value);
    this.setState({
      value: e.target.value[this.state.valueKey || 'value'] || e.target.value
    });
  };

  onChange1 = e => this.setState({ value1: e.target.value });

  onChange2 = e => this.setState({ value2: e.target.value });

  onChangeProps = (e, key, value) => {
    const props = e.target.value;

    if (key === 'options') {
      props['orgOptions'] = value; // we store the unfiltered values in orgOptions so that the displayed list can be filtered
    }
    this.setState(props);
  };

  onSearch = e => {
    this.setState({
      options: this.state.orgOptions.filter(option => (option.label || option).indexOf(e.target.value) > -1)
    });
  };

  onToggleRenderer = () => {
    const customRenderer = !this.state.customRenderer;

    this.setState({
      customRenderer,
      itemRenderer: customRenderer ? this.itemRenderer : undefined,
    });
  };

  itemRenderer = item => {
    let label = item;

    if (typeof item === 'object') {
      label = item[this.state.labelKey || 'label'];
    }
    return <div className="custom-renderer"><Icon name="user" />{label}</div>;
  };

  repaint = () => this.forceUpdate();

  render() {
    const { customRenderer, itemRenderer, options, value, value1, value2 } = this.state;

    return (
      <Example {...this.props}>
        <Properties defaultProps={SelectList.defaultProps} propTypes={SelectList.propTypes} propValues={this.state} onChange={this.onChangeProps} />
        <div className="lists">
          <Group title="Object array">
            <SelectList value={value} itemRenderer={itemRenderer} options={options} onChange={this.onChange} onSearch={this.onSearch} onBlur={this.repaint} onFocus={this.repaint} />
          </Group>
          <Group title="Nested array of objects">
            <SelectList value={value1} itemRenderer={itemRenderer} onChange={this.onChange1} options={NESTED_OPTIONS} nestedKey="children" nestedKeySelectable="selectable" />
          </Group>
          <Group title="String array">
            <SelectList value={value2} itemRenderer={itemRenderer} onChange={this.onChange2} options={['This is option 1', 'This is option 2', 'This is option 3']} />
          </Group>
        </div>
        <Checkbox checked={customRenderer} onChange={this.onToggleRenderer} label="Use custom renderer" />
        <SourceCode querySelector=".core-select-list" />
      </Example>
    );
  }

}
